module.exports = __webpack_public_path__ + "static/media/banner-gray-slant-img.4fe458e2.png";